import React from "react";
import "./index.scss";
import NavBar from "../../NavBar";

type Props = {
  children: any;
};

const Layout: React.FC<Props> = ({ children }) => {
  return (
    <div className="layout_container">
      <NavBar />
      <div className="layout_container__content">{children}</div>
    </div>
  );
};

export default Layout;
